import React from 'react';
import { Accordion, Heading, IconExternal, Paragraph, TextButton } from '@zillow/constellation';
import { URLS } from '../../constants/urls';

export default function Faqs() {
  return (
    <>
      <Heading level="4" marginY="md">
        Resources
      </Heading>
      <Accordion>
        <Accordion.Item>
          <Accordion.Header>
            <Heading level="5">How do applications work?</Heading>
          </Accordion.Header>
          <Accordion.Panel>
            <Paragraph>
              Prospective renters send you an identity-verified renter application with a freshly pulled credit report,
              criminal background check and eviction record.
            </Paragraph>
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header>
            <Heading level="5">Where can I see a sample application and reports?</Heading>
          </Accordion.Header>
          <Accordion.Panel>
            <Paragraph>
              <TextButton as="a" href={URLS.SAMPLE_ONLINE_APPLICATION} target="_blank">
                Sample online rental application
              </TextButton>
            </Paragraph>
            <Paragraph marginTop="sm">
              <TextButton as="a" href={URLS.SAMPLE_BACKGROUND_CHECK} target="_blank">
                Sample tenant background check
              </TextButton>
            </Paragraph>
            <Paragraph marginTop="sm">
              <TextButton as="a" href={URLS.SAMPLE_CREDIT_REPORT} target="_blank">
                Sample credit report
              </TextButton>
            </Paragraph>
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header>
            <Heading level="5">Have more questions?</Heading>
          </Accordion.Header>
          <Accordion.Panel>
            <Paragraph>
              <TextButton as="a" href={URLS.FAQS} target="_blank" icon={<IconExternal />} iconPosition="end">
                Full list of FAQs
              </TextButton>
            </Paragraph>
            <Paragraph marginTop="sm">Still have a question?</Paragraph>
            <Paragraph marginTop="sm">
              <TextButton as="a" href={URLS.NEW_ZENDESK_REQUEST} target="_blank">
                Contact us
              </TextButton>
            </Paragraph>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
